/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateYoutubeVideoConfigReqVo
 */
export interface UpdateYoutubeVideoConfigReqVo {
    /**
     * 缩略图OSS地址
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    thumbnailUrl: string;
    /**
     * YouTube原始完整视频链接
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    videoUrl: string;
    /**
     * 视频标题（韩文）
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    titleKr: string;
    /**
     * 视频标题（中文）
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    titleCn: string;
    /**
     * 视频简介（韩文）
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    descriptionKr?: string;
    /**
     * 视频简介（中文）
     * @type {string}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    descriptionCn?: string;
    /**
     * 展示排序，数值越小越靠前；未删除记录中不可重复
     * @type {number}
     * @memberof UpdateYoutubeVideoConfigReqVo
     */
    sortNo?: number;
}

/**
 * Check if a given object implements the UpdateYoutubeVideoConfigReqVo interface.
 */
export function instanceOfUpdateYoutubeVideoConfigReqVo(value: object): value is UpdateYoutubeVideoConfigReqVo {
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('videoUrl' in value) || value['videoUrl'] === undefined) return false;
    if (!('titleKr' in value) || value['titleKr'] === undefined) return false;
    if (!('titleCn' in value) || value['titleCn'] === undefined) return false;
    return true;
}

export function UpdateYoutubeVideoConfigReqVoFromJSON(json: any): UpdateYoutubeVideoConfigReqVo {
    return UpdateYoutubeVideoConfigReqVoFromJSONTyped(json, false);
}

export function UpdateYoutubeVideoConfigReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateYoutubeVideoConfigReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'thumbnailUrl': json['thumbnailUrl'],
        'videoUrl': json['videoUrl'],
        'titleKr': json['titleKr'],
        'titleCn': json['titleCn'],
        'descriptionKr': json['descriptionKr'] == null ? undefined : json['descriptionKr'],
        'descriptionCn': json['descriptionCn'] == null ? undefined : json['descriptionCn'],
        'sortNo': json['sortNo'] == null ? undefined : json['sortNo'],
    };
}

export function UpdateYoutubeVideoConfigReqVoToJSON(json: any): UpdateYoutubeVideoConfigReqVo {
    return UpdateYoutubeVideoConfigReqVoToJSONTyped(json, false);
}

export function UpdateYoutubeVideoConfigReqVoToJSONTyped(value?: UpdateYoutubeVideoConfigReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thumbnailUrl': value['thumbnailUrl'],
        'videoUrl': value['videoUrl'],
        'titleKr': value['titleKr'],
        'titleCn': value['titleCn'],
        'descriptionKr': value['descriptionKr'],
        'descriptionCn': value['descriptionCn'],
        'sortNo': value['sortNo'],
    };
}

